































import { Vue, Component, Prop } from "vue-property-decorator";

// Enums
import { ProductTypes } from "@/data/enums/products";

@Component({
  components: {
    "multilevel-select-products": () =>
      import(
        "@/components/app/admin/catalogue/products/multilevelCategories/multilevelSelectProducts.vue"
      )
  }
})
export default class MultilevelSelectProductsModal extends Vue {
  // Props
  @Prop({ default: [ProductTypes.SINGLE_PRODUCT, ProductTypes.PRODUCT_BUNDLE] })
  public productTypes!: ProductTypes[];

  @Prop({ required: true })
  public selectedProducts!: any[];

  @Prop({ default: true })
  public disableBundles!: boolean;

  @Prop({ default: () => [] })
  public disabledProducts!: number[];

  // Variables
  public newSelectedProducts: any[] = [];

  public created() {
    this.newSelectedProducts = this.$_.clone(this.selectedProducts);
  }

  public get productTypesEnums() {
    return ProductTypes;
  }

  public saveChanges() {
    this.$emit("success", this.newSelectedProducts);
    this.$emit("close");
  }

  public get buttonIsDisabled() {
    return this.selectedProductsNotChanged;
  }

  public get selectedProductsNotChanged() {
    return this.$_.isEqual(
      this.$_.sortBy(this.$_.map(this.selectedProducts, product => product.id)),
      this.$_.sortBy(
        this.$_.map(this.newSelectedProducts, newProduct => newProduct.id)
      )
    );
  }
}
